import request from '../utils/request'
import { getToken } from '../utils/auth'

export function createAudio(data) {
  return request({
    url: '/api/audios',
    method: 'post',
    params: {
      'access_token': getToken()
    },
    data
  })
}

export function deleteAudio(id) {
  return request({
    url: '/api/audios/' + id + '/removeWithFile',
    method: 'delete',
    params: {
      'access_token': getToken()
    }
  })
}

